export default "__VITE_ASSET__vgzOjH4s__"